<template>
  <button @click="toggleFavorite" class="btn btn-outline-danger btn-favorite">
    <i class="bi" :class="isFavorite ? 'bi-heart-fill' : 'bi-heart'"></i>
  </button>
</template>

<script>
import axios from 'axios';
import { router } from '@inertiajs/vue3';

export default {
  name: 'FavoriteButton',
  props: {
    productId: {
      type: Number,
      required: true
    },
    initialFavoriteStatus: {
      type: Boolean,
      default: false
    },
    isAuthenticated: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFavorite: this.initialFavoriteStatus,
      isProcessing: false
    }
  },
  mounted() {
    if (this.isAuthenticated) {
      this.checkFavoriteStatus();
    }
  },
  methods: {
    async checkFavoriteStatus() {
      try {
        const response = await axios.get(`/api/favorites/check/${this.productId}`);
        // Check if response has the new format with status property
        if (response.data && typeof response.data.status !== 'undefined') {
          this.isFavorite = response.data.status;
        } else {
          // Fallback for backward compatibility - check if response.data is not empty
          // Empty objects {} should be treated as not favorited
          this.isFavorite = response.data && Object.keys(response.data).length > 0;
        }
      } catch (error) {
        console.error('Error checking favorite status:', error);
        this.isFavorite = false;
      }
    },
    async toggleFavorite() {
      if (this.isProcessing) return;
      this.isProcessing = true;
      
      try {
        if (this.isFavorite) {
          await axios.delete(`/api/favorites/${this.productId}`);
        } else {
          await axios.post('/api/favorites', {
            product_id: this.productId
          });
        }
        
        this.isFavorite = !this.isFavorite;
        this.$emit('favorite-changed', this.isFavorite);
      } catch (error) {
        console.error('Error toggling favorite:', error);
        
        if (error.response && error.response.status === 401) {
          // User is not authenticated, redirect to login via Inertia
          router.visit('/login?redirect=' + encodeURIComponent(window.location.pathname));
        } else {
          // If there's an error but the action was to remove a favorite,
          // we should still update the UI as if it worked
          if (this.isFavorite) {
            this.isFavorite = false;
            this.$emit('favorite-changed', false);
          } else {
            alert('Der opstod en fejl. Prøv igen senere.');
          }
        }
      } finally {
        this.isProcessing = false;
      }
    }
  }
}
</script>

<style scoped>
.btn-favorite {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  background-color: transparent;
  color: var(--pc-text-secondary, #adb5bd);
  border: 1px solid var(--pc-border, rgba(255, 255, 255, 0.15));
  transition: all 0.2s ease;
  padding: 0;
}

.btn-favorite:hover,
.btn-favorite.active {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  border-color: #dc3545;
  transform: translateY(-1px);
}

.btn-favorite i {
  font-size: 1rem;
  transition: transform 0.2s ease;
}

.btn-favorite i.bi-heart-fill {
  color: #dc3545;
}

.btn-favorite:active i {
  transform: scale(1.2);
}
</style>
